import { faBadgeCheck, faCheckCircle, faClock, faXmark } from "@fortawesome/pro-regular-svg-icons";
import {
  faArrowRightFromBracket,
  faBan,
  faBell,
  faBuilding,
  faCalendarAlt,
  faCheck,
  faCheckDouble,
  faCircleHalfStroke,
  faCoinBlank,
  faCoins,
  faCopy,
  faDoorOpen,
  faDownload,
  faEuroSign,
  faEye,
  faFile,
  faFileContract,
  faFilter,
  faGauge,
  faGrip,
  faHandHoldingDollar,
  faInbox,
  faPaperPlane,
  faPiggyBank,
  faQuestion,
  faSack,
  faSearch,
  faSignature,
  faTimes,
  faTrashCan,
  faUndo,
  faUser,
  faUsers,
  faUserTie
} from "@fortawesome/pro-solid-svg-icons";

const icons = [
  faUsers,
  faUser,
  faSearch,
  faFileContract,
  faBuilding,
  faPaperPlane,
  faEuroSign,
  faCheck,
  faTimes,
  faCalendarAlt,
  faDownload,
  faUserTie,
  faPiggyBank,
  faCheckCircle,
  faClock,
  faBell,
  faBadgeCheck,
  faCircleHalfStroke,
  faCopy,
  faFilter,
  faGauge,
  faCoinBlank,
  faCoins,
  faSack,
  faEye,
  faCheckDouble,
  faSignature,
  faArrowRightFromBracket,
  faHandHoldingDollar,
  faDoorOpen,
  faUndo,
  faBan,
  faFile,
  faInbox,
  faQuestion,
  faXmark,
  faTrashCan,
  faGrip
];

const aliases = {
  notification: "fas fa-bell",
  theme: "fas fa-circle-half-stroke",
  filter: "fas fa-filter",

  preScans: "fas fa-grip",
  funder: "fas fa-piggy-bank",
  consumer: "fas fa-user",
  business: "fas fa-building",
  user: "fas fa-user",
  search: "fas fa-search",
  dashboard: "fas fa-gauge",
  financeReceiver: "fas fa-hand-holding-dollar",

  fundingContract: "fas fa-file-contract",

  financeReceiverStatusPreScanSubmitted: "fas fa-inbox",
  financeReceiverStatusPreScanInProgress: "far fa-clock",
  financeReceiverStatusPreScanRejected: "fas fa-ban",
  financeReceiverStatusPreScanWithdrawn: "fas fa-undo",
  financeReceiverStatusInactive: "fas fa-times",
  financeReceiverStatusActive: "fas fa-euro-sign",
  financeReceiverStatusDelinquent: "fas fa-exclamation-triangle",
  financeReceiverStatusDefaulting: "fas fa-exclamation",
  financeReceiverStatusOffboarded: "fas fa-door-open",

  fundingContractStatusDraft: "fas fa-pencil",
  fundingContractStatusSent: "fas fa-paper-plane",
  fundingContractStatusAccepted: "fas fa-signature",
  fundingContractStatusValidated: "fas fa-check-double",
  fundingContractStatusActive: "fas fa-euro-sign",
  fundingContractStatusInactive: "fas fa-times",

  logout: "fas fa-arrow-right-from-bracket",
  account: "fas fa-user-tie",

  Prescanstep1: "fas fa-pencil",
  Prescanstep2: "fas fa-file",
  Prescanstep3: "fas fa-coins",
  Prescanstep8: "fas fa-check-double",
  Prescanstep5: "fas fa-user",
  Prescanstep9: "fas fa-user",
  PrescanemailOption: "fas fa-question",

  true: "fas fa-check",
  false: "fas fa-times",

  calender: "fas fa-calendar-alt",
  download: "fas fa-download",
  copy: "fas fa-copy",
  open: "fas fa-eye",

  waiting: "far fa-clock",
  done: "far fa-check-circle",

  tasksDone: "far fa-badge-check",

  delete: "fas fa-trash-can",

  bronzePartner: "fas fa-coin-blank",
  silverPartner: "fas fa-coins",
  goldPartner: "fas fa-sack"
};

export default {
  aliases,
  icons
};
